import { keyBy } from 'lodash';

const completedScreen = 73;

const prepScreens = keyBy(
    [
        {
            id: 16,
            description: 'Have you ever been prescribed PrEP?',
            defaultNextScreen: null
        },
        {
            id: 17,
            description: 'Type of PrEP',
            defaultNextScreen: null
        },
        {
            id: 18,
            description: 'PrEP prescription',
            defaultNextScreen: null
        },
        {
            id: 19,
            description: 'Resources - Back on PrEP',
            defaultNextScreen: completedScreen
        },
        {
            id: 20,
            description: 'Resources - Starting PrEP',
            defaultNextScreen: completedScreen
        },
        {
            id: 21,
            description: 'Moving along',
            defaultNextScreen: completedScreen
        },
        {
            id: 22,
            description: 'Prep commitment level',
            defaultNextScreen: null
        },
        {
            id: 23,
            description: 'Behavior motivators',
            defaultNextScreen: 25
        },
        {
            id: 24,
            description: 'Resources - No Prep commitment',
            defaultNextScreen: completedScreen
        },
        {
            id: 25,
            description: 'Prep adherence screener',
            defaultNextScreen: null
        },
        {
            id: 26,
            description: 'Prep adherence scores - low',
            defaultNextScreen: 30
        },
        {
            id: 27,
            description: 'Prep adherence scores - perfect',
            defaultNextScreen: completedScreen
        },
        {
            id: 28,
            description: 'Prep adherence scores - high',
            defaultNextScreen: null
        },
        {
            id: 29,
            description: 'Prep adherence scores - starting',
            defaultNextScreen: completedScreen
        },
        {
            id: 30,
            description: 'Importance of change - Important Points',
            defaultNextScreen: 31
        },
        {
            id: 31,
            description: 'Importance of change - Gaps',
            defaultNextScreen: 32
        },
        {
            id: 32,
            description: 'Downsides of not taking prep daily',
            defaultNextScreen: 33
        },
        {
            id: 33,
            description: 'Barriers to change',
            defaultNextScreen: 34
        },
        {
            id: 34,
            description: 'Barriers to change - reasons',
            defaultNextScreen: 35
        },
        {
            id: 35,
            description: 'Explore ways to take Prep regularly',
            defaultNextScreen: null
        },
        {
            id: 36,
            description: 'Strategies for taking Prep daily',
            defaultNextScreen: 37
        },
        {
            id: 37,
            description: 'Change motivators',
            defaultNextScreen: 38
        },
        {
            id: 38,
            description: 'Readiness to change',
            defaultNextScreen: null
        },
        {
            id: 39,
            description: 'Readiness to change - rarely',
            defaultNextScreen: 40
        },
        {
            id: 40,
            description: 'Readiness to change - 3 important points',
            defaultNextScreen: 41
        },
        {
            id: 41,
            description: 'Readiness to change - review strategies',
            defaultNextScreen: 42
        },
        {
            id: 42,
            description: 'Readiness to change - scale',
            defaultNextScreen: 43
        },
        {
            id: 43,
            description: 'Readiness to change - wrap up',
            defaultNextScreen: 44
        },
        {
            id: 44,
            description: 'Prep final review',
            defaultNextScreen: completedScreen
        }
    ],
    'id'
);

const prepChoices = keyBy(
    [
        {
            id: 1,
            text: 'Yes, and I’m now on PrEP (or just starting PrEP)',
            selected: false,
            userEntered: false,
            nextScreen: 17
        },
        {
            id: 2,
            text: 'Yes, but I’m no longer on PrEP',
            selected: false,
            userEntered: false,
            nextScreen: 19
        },
        {
            id: 3,
            text: 'No',
            selected: false,
            userEntered: false,
            nextScreen: 20
        },
        {
            id: 4,
            text: 'I’m interested in taking PrEP but would like more information first',
            selected: false,
            userEntered: false,
            nextScreen: 20
        },
        {
            id: 5,
            text: 'I would like to take PrEP but don’t know where to start',
            selected: false,
            userEntered: false,
            nextScreen: 20
        },
        {
            id: 6,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null,
            nextScreen: 20
        }
    ],
    'id'
);

const prepTypes = keyBy(
    [
        {
            id: 1,
            text: 'Oral medication (pills)',
            selected: false,
            nextScreen: 18
        },
        {
            id: 2,
            text: 'Injections',
            selected: false,
            nextScreen: 21
        }
    ],
    'id'
);

const prepPrescription = keyBy(
    [
        {
            id: 1,
            text: 'daily PrEP',
            selected: false,
            nextScreen: 22
        },
        {
            id: 2,
            text: '“on-demand” PrEP - only when sexually active',
            selected: false,
            nextScreen: 21
        }
    ],
    'id'
);

const prepCommitment = keyBy(
    [
        {
            id: 1,
            text: 'I’m 100% committed',
            selected: false,
            nextScreen: 23
        },
        {
            id: 2,
            text: 'I’m somewhat committed',
            selected: false,
            nextScreen: 23
        },
        {
            id: 3,
            text: 'I’m not committed at all',
            selected: false,
            nextScreen: 24
        }
    ],
    'id'
);

const prepMotivators = keyBy(
    [
        {
            id: 1,
            text: 'I want to have safer sex',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I want to have sex without a condom',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I want to decrease my risk of getting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I do not want to jeopardize my sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I want to keep my partner(s) safer',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I want to feel empowered to take charge of my sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I want to decrease my anxiety around sex and sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I want to feel responsible for my sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I want to be honest with my partner(s) and friends about taking PrEP regularly',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I want to be a role model for other trans women and/or trans femme folks',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'I want to have safer sex with my partner(s) who is HIV positive',
            selected: false,
            userEntered: false
        },
        {
            id: 12,
            text: 'I want to improve my relationship with my partner(s)',
            selected: false,
            userEntered: false
        },
        {
            id: 13,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const prepAdherence = keyBy(
    [
        {
            id: 1,
            text: 'Every day',
            selected: false,
            nextScreen: 27
        },
        {
            id: 2,
            text: '4-6 times a week',
            selected: false,
            nextScreen: 28
        },
        {
            id: 3,
            text: '1-3 times a week',
            selected: false,
            nextScreen: 26
        },
        {
            id: 4,
            text: 'Never',
            selected: false,
            nextScreen: 26
        },
        {
            id: 5,
            text: 'I just got prescribed PrEP and I haven’t started taking it yet',
            selected: false,
            nextScreen: 29
        }
    ],
    'id'
);

const prepAdherenceSupport = keyBy(
    [
        {
            id: 1,
            text: 'Yes',
            selected: false,
            nextScreen: 30
        },
        {
            id: 2,
            text: 'No',
            selected: false,
            nextScreen: completedScreen
        }
    ],
    'id'
);

const prepAdherenceGaps = keyBy(
    [
        {
            id: 1,
            text: 'Before today, I hadn’t realized this gap existed!',
            selected: false
        },
        {
            id: 2,
            text: 'I don’t think taking PrEP every day is important for me.',
            selected: false
        },
        {
            id: 3,
            text: 'I don’t think I’m someone who’s good at taking medication on a regular basis.',
            selected: false
        },
        {
            id: 4,
            text: 'I don’t know why there’s a gap between my commitment to safety, my knowledge about PrEP, and my actual behavior.',
            selected: false
        }
    ],
    'id'
);

const prepIrregularDownsides = keyBy(
    [
        {
            id: 1,
            text: 'I have to CORRECTLY and CONSISTENTLY use condoms to have the best chances of protecting myself from getting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I’m at an increased risk of getting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I feel less empowered over my sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I get anxious or worried about sex and sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I feel judged about not protecting myself the best way I can',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I have to share with my partner(s) that I am not regularly taking PrEP',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I’m disappointed in myself for missing a dose',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I have more fear about getting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I feel less in control of my HIV status',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I feel my partner(s) is at higher risk of getting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'I worry that having sex with my HIV positive partner(s) is higher risk',
            selected: false,
            userEntered: false
        },
        {
            id: 12,
            text: 'I hesitate to have sex with new people',
            selected: false,
            userEntered: false
        },
        {
            id: 13,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const prepBarriers = keyBy(
    [
        {
            id: 1,
            text: 'I have concerns about possible long-term side effects',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I have a busy schedule',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I run out of medication',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I can’t afford PrEP',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I have concerns that other people will judge me',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I have some side-effects',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I forget to take PrEP',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I don’t like my PrEP prescriber',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I’ve had bad experiences with doctors or other medical providers',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I don’t feel supported to take PrEP by others around me',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'I’m concerned about PrEP affecting my hormones or making them less effective',
            selected: false,
            userEntered: false
        },
        {
            id: 12,
            text: 'I don’t think taking PrEP on a regular basis is important',
            selected: false,
            userEntered: false
        },
        {
            id: 13,
            text: 'I don’t want to take PrEP on a regular basis',
            selected: false,
            userEntered: false
        },
        {
            id: 14,
            text: 'I don’t want to have a follow-up with my PrEP prescriber every 3 months',
            selected: false,
            userEntered: false
        },
        {
            id: 15,
            text: 'I feel embarrassed to take PrEP',
            selected: false,
            userEntered: false
        },
        {
            id: 16,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const prepRegularSupport = keyBy(
    [
        {
            id: 1,
            text: 'Yes, I would like some ideas on how I can take PrEP more regularly',
            selected: false,
            nextScreen: 36
        },
        {
            id: 2,
            text: 'No thanks',
            selected: false,
            nextScreen: 37
        }
    ],
    'id'
);

const prepRegularStrategies = keyBy(
    [
        {
            id: 1,
            text:
                'I could use a small pill box. A weekly pill box with a section for each day can remind you to take your PrEP and help prevent taking it twice by mistake.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 2,
            text: 'I could integrate PrEP as part of my daily routine',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 3,
            text: 'I could take PrEP at the same time as my vitamins or other medications',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 4,
            text: 'I could set a smart phone reminder',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 5,
            text: 'I could set up a buddy reminder system with a friend/partner. This way both of us can remind each other to take our PrEP',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 6,
            text: 'I could carry extra doses',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 7,
            text:
                'I could use a medication reminder app such as the Walgreens app, “Alarm and Pill Reminder”, or “Pill Reminder & Medication Tracker” by MyTherapy.',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 8,
            text:
                'I could make up a reminder system that’s super noticeable to me (e.g., a random sticker on my makeup box or bathroom mirror, a string next to my keys, a note on the refrigerator, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 9,
            text: 'I could keep a calendar to write down when refills are due and when I need to schedule a doctor’s appointment',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 10,
            text: 'I could take PrEP with an activity that I do at the same time every day (e.g., brushing teeth, eating lunch, feeding a pet, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 11,
            text: 'I could leave medication in a safe place that is easy to spot. ',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 12,
            text:
                'I could link up with a sexual health educator (or other support person) who can help me get access to health care, doctors, prescriptions, etc.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 13,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null,
            reminderStrategy: false
        }
    ],
    'id'
);

const prepMotivatorsRevisited = keyBy(
    [
        {
            id: 1,
            text: 'I want to have safer sex',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I want to have sex without a condom',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I want to decrease my risk of getting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I do not want to jeopardize my sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I want to keep my partner(s) safer',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I want to feel empowered to take charge of my sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I want to decrease my anxiety around sex and sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I want to feel responsible for my sexual health',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I want to be honest with my partner(s) and friends about taking PrEP regularly',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I want to be a role model for other trans women and/or trans femme folks',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'I want to have safer sex with my partner(s) who is HIV positive',
            selected: false,
            userEntered: false
        },
        {
            id: 12,
            text: 'I want to improve my relationship with my partner(s)',
            selected: false,
            userEntered: false
        },
        {
            id: 13,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const prepAdherenceRevisited = keyBy(
    [
        {
            id: 1,
            text: 'Every day',
            selected: false,
            nextScreen: 40
        },
        {
            id: 2,
            text: '4-6 times a week',
            selected: false,
            nextScreen: 40
        },
        {
            id: 3,
            text: '1-3 times a week',
            selected: false,
            nextScreen: 39
        },
        {
            id: 4,
            text: 'Never',
            selected: false,
            nextScreen: 39
        }
    ],
    'id'
);

const prepRegularStrategiesRevisited = keyBy(
    [
        {
            id: 1,
            text:
                'I could use a small pill box. A weekly pill box with a section for each day can reminder you to take your PrEP and help prevent taking it twice by mistake.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 2,
            text: 'I could integrate PrEP as part of my daily routine',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 3,
            text: 'I could take PrEP at the same time as my vitamins or other medications',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 4,
            text: 'I could set a smart phone reminder',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 5,
            text: 'I could set up a buddy reminder system with a friend/partner. This way both of us can remind each other to take our PrEP',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 6,
            text: 'I could carry extra doses',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 7,
            text:
                'I could use a medication reminder app such as the Walgreens app, “Alarm and Pill Reminder”, or “Pill Reminder & Medication Tracker” by MyTherapy.',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 8,
            text:
                'I could make up a reminder system that’s super noticeable to me (e.g., a random sticker on my makeup box or bathroom mirror, a string next to my keys, a note on the refrigerator, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 9,
            text: 'I could keep a calendar to write down when refills are due and when I need to schedule a doctor’s appointment',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 10,
            text: 'I could take PrEP with an activity that I do at the same time every day (e.g., brushing teeth, eating lunch, feeding a pet, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 11,
            text: 'I could leave medication in a safe place that is easy to spot. ',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 12,
            text:
                'I could link up with a sexual health educator (or other support person) who can help me get access to health care, doctors, prescriptions, etc.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 13,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null,
            reminderStrategy: false
        }
    ],
    'id'
);

const prepReminder = keyBy(
    [
        {
            id: 1,
            text: 'Yes, I really did set a reminder',
            selected: false
        },
        {
            id: 2,
            text: 'No, I didn’t but I will now',
            selected: false
        },
        {
            id: 3,
            text: 'No, I have decided that an alarm and a reminder is not the best option for me',
            selected: false
        }
    ],
    'id'
);

export {
    prepScreens,
    prepChoices,
    prepTypes,
    prepPrescription,
    prepCommitment,
    prepMotivators,
    prepAdherence,
    prepAdherenceSupport,
    prepAdherenceGaps,
    prepIrregularDownsides,
    prepBarriers,
    prepRegularSupport,
    prepRegularStrategies,
    prepMotivatorsRevisited,
    prepAdherenceRevisited,
    prepRegularStrategiesRevisited,
    prepReminder
};
